import { render, staticRenderFns } from "./Serial.vue?vue&type=template&id=18937eb2&scoped=true"
import script from "./Serial.vue?vue&type=script&lang=js"
export * from "./Serial.vue?vue&type=script&lang=js"
import style0 from "./Serial.vue?vue&type=style&index=0&id=18937eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18937eb2",
  null
  
)

export default component.exports